const stateData = [
    {
      "state": "AK",
      "lat": 63.588753,
      "lng": -154.493062,
      "name": "Alaska"
    },
    {
      "state": "AL",
      "lat": 32.318231,
      "lng": -86.902298,
      "name": "Alabama"
    },
    {
      "state": "AR",
      "lat": 35.20105,
      "lng": -91.831833,
      "name": "Arkansas"
    },
    {
      "state": "AZ",
      "lat": 34.048928,
      "lng": -111.093731,
      "name": "Arizona"
    },
    {
      "state": "CA",
      "lat": 36.778261,
      "lng": -119.417932,
      "name": "California"
    },
    {
      "state": "CO",
      "lat": 39.550051,
      "lng": -105.782067,
      "name": "Colorado"
    },
    {
      "state": "CT",
      "lat": 41.603221,
      "lng": -73.087749,
      "name": "Connecticut"
    },
    {
      "state": "DC",
      "lat": 38.905985,
      "lng": -77.033418,
      "name": "District of Columbia"
    },
    {
      "state": "DE",
      "lat": 38.910832,
      "lng": -75.52767,
      "name": "Delaware"
    },
    {
      "state": "FL",
      "lat": 27.664827,
      "lng": -81.515754,
      "name": "Florida"
    },
    {
      "state": "GA",
      "lat": 32.157435,
      "lng": -82.907123,
      "name": "Georgia"
    },
    {
      "state": "HI",
      "lat": 19.898682,
      "lng": -155.665857,
      "name": "Hawaii"
    },
    {
      "state": "IA",
      "lat": 41.878003,
      "lng": -93.097702,
      "name": "Iowa"
    },
    {
      "state": "ID",
      "lat": 44.068202,
      "lng": -114.742041,
      "name": "Idaho"
    },
    {
      "state": "IL",
      "lat": 40.633125,
      "lng": -89.398528,
      "name": "Illinois"
    },
    {
      "state": "IN",
      "lat": 40.551217,
      "lng": -85.602364,
      "name": "Indiana"
    },
    {
      "state": "KS",
      "lat": 39.011902,
      "lng": -98.484246,
      "name": "Kansas"
    },
    {
      "state": "KY",
      "lat": 37.839333,
      "lng": -84.270018,
      "name": "Kentucky"
    },
    {
      "state": "LA",
      "lat": 31.244823,
      "lng": -92.145024,
      "name": "Louisiana"
    },
    {
      "state": "MA",
      "lat": 42.407211,
      "lng": -71.382437,
      "name": "Massachusetts"
    },
    {
      "state": "MD",
      "lat": 39.045755,
      "lng": -76.641271,
      "name": "Maryland"
    },
    {
      "state": "ME",
      "lat": 45.253783,
      "lng": -69.445469,
      "name": "Maine"
    },
    {
      "state": "MI",
      "lat": 44.314844,
      "lng": -85.602364,
      "name": "Michigan"
    },
    {
      "state": "MN",
      "lat": 46.729553,
      "lng": -94.6859,
      "name": "Minnesota"
    },
    {
      "state": "MO",
      "lat": 37.964253,
      "lng": -91.831833,
      "name": "Missouri"
    },
    {
      "state": "MS",
      "lat": 32.354668,
      "lng": -89.398528,
      "name": "Mississippi"
    },
    {
      "state": "MT",
      "lat": 46.879682,
      "lng": -110.362566,
      "name": "Montana"
    },
    {
      "state": "NC",
      "lat": 35.759573,
      "lng": -79.0193,
      "name": "North Carolina"
    },
    {
      "state": "ND",
      "lat": 47.551493,
      "lng": -101.002012,
      "name": "North Dakota"
    },
    {
      "state": "NE",
      "lat": 41.492537,
      "lng": -99.901813,
      "name": "Nebraska"
    },
    {
      "state": "NH",
      "lat": 43.193852,
      "lng": -71.572395,
      "name": "New Hampshire"
    },
    {
      "state": "NJ",
      "lat": 40.058324,
      "lng": -74.405661,
      "name": "New Jersey"
    },
    {
      "state": "NM",
      "lat": 34.97273,
      "lng": -105.032363,
      "name": "New Mexico"
    },
    {
      "state": "NV",
      "lat": 38.80261,
      "lng": -116.419389,
      "name": "Nevada"
    },
    {
      "state": "NY",
      "lat": 43.299428,
      "lng": -74.217933,
      "name": "New York"
    },
    {
      "state": "OH",
      "lat": 40.417287,
      "lng": -82.907123,
      "name": "Ohio"
    },
    {
      "state": "OK",
      "lat": 35.007752,
      "lng": -97.092877,
      "name": "Oklahoma"
    },
    {
      "state": "OR",
      "lat": 43.804133,
      "lng": -120.554201,
      "name": "Oregon"
    },
    {
      "state": "PA",
      "lat": 41.203322,
      "lng": -77.194525,
      "name": "Pennsylvania"
    },
    {
      "state": "PR",
      "lat": 18.220833,
      "lng": -66.590149,
      "name": "Puerto Rico"
    },
    {
      "state": "RI",
      "lat": 41.580095,
      "lng": -71.477429,
      "name": "Rhode Island"
    },
    {
      "state": "SC",
      "lat": 33.836081,
      "lng": -81.163725,
      "name": "South Carolina"
    },
    {
      "state": "SD",
      "lat": 43.969515,
      "lng": -99.901813,
      "name": "South Dakota"
    },
    {
      "state": "TN",
      "lat": 35.517491,
      "lng": -86.580447,
      "name": "Tennessee"
    },
    {
      "state": "TX",
      "lat": 31.968599,
      "lng": -99.901813,
      "name": "Texas"
    },
    {
      "state": "UT",
      "lat": 39.32098,
      "lng": -111.093731,
      "name": "Utah"
    },
    {
      "state": "VA",
      "lat": 37.431573,
      "lng": -78.656894,
      "name": "Virginia"
    },
    {
      "state": "VT",
      "lat": 44.558803,
      "lng": -72.577841,
      "name": "Vermont"
    },
    {
      "state": "WA",
      "lat": 47.751074,
      "lng": -120.740139,
      "name": "Washington"
    },
    {
      "state": "WI",
      "lat": 43.78444,
      "lng": -88.787868,
      "name": "Wisconsin"
    },
    {
      "state": "WV",
      "lat": 38.597626,
      "lng": -80.454903,
      "name": "West Virginia"
    },
    {
      "state": "WY",
      "lat": 43.075968,
      "lng": -107.290284,
      "name": "Wyoming"
    }
]

export default stateData;